import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCart } from '../../context/CartContext';
import { CartItem as CartItemType } from '../../types';
import { getImageUrl } from '../../utils/imageUrl';
import './CartItem.css';

interface CartItemProps {
  item: CartItemType;
}

const CartItem: React.FC<CartItemProps> = ({ item }) => {
  const { t, i18n } = useTranslation();
  const { updateQuantity, removeItem } = useCart();
  const { product, quantity } = item;

  const currentLang = i18n.language;
  const productName = currentLang === 'bn' ? product.name_bn : product.name_en;
  const price = product.final_price || product.price;
  const subtotal = price * quantity;

  const productImage = getImageUrl(
    product.image || product.primary_image || product.images?.[0]?.image
  );

  const handleQuantityChange = (newQuantity: number) => {
    if (newQuantity > 0 && newQuantity <= product.stock) {
      updateQuantity(product.id, newQuantity);
    }
  };

  return (
    <div className="cart-item">
      <div className="cart-item-image">
        <img src={productImage} alt={productName} />
      </div>

      <div className="cart-item-details">
        <h3>{productName}</h3>
        {product.discount_percentage > 0 && (
          <span className="discount-badge">{product.discount_percentage}%</span>
        )}
        {(item.selected_color || item.selected_size || item.selected_weight) && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '4px' }}>
            {item.selected_color && (
              <span style={{
                display: 'inline-flex', alignItems: 'center', gap: '4px',
                padding: '1px 7px', borderRadius: '12px', fontSize: '11px',
                background: '#F3F4F6', color: '#374151', border: '1px solid #E5E7EB',
              }}>
                <span style={{
                  width: '8px', height: '8px', borderRadius: '50%',
                  background: item.selected_color, border: '1px solid #ccc',
                  flexShrink: 0,
                }} />
                {item.selected_color}
              </span>
            )}
            {item.selected_size && (
              <span style={{
                padding: '1px 7px', borderRadius: '12px', fontSize: '11px',
                background: '#EEF2FF', color: '#4F46E5', border: '1px solid #C7D2FE',
              }}>
                {item.selected_size}
              </span>
            )}
            {item.selected_weight && (
              <span style={{
                padding: '1px 7px', borderRadius: '12px', fontSize: '11px',
                background: '#ECFDF5', color: '#059669', border: '1px solid #A7F3D0',
              }}>
                {item.selected_weight}
              </span>
            )}
          </div>
        )}
      </div>

      <div className="cart-item-price">
        ৳{price.toFixed(2)}
      </div>

      <div className="cart-item-quantity">
        <button 
          onClick={() => handleQuantityChange(quantity - 1)}
          disabled={quantity <= 1}
        >
          -
        </button>
        <span>{quantity}</span>
        <button 
          onClick={() => handleQuantityChange(quantity + 1)}
          disabled={quantity >= product.stock}
        >
          +
        </button>
      </div>

      <div className="cart-item-subtotal">
        ৳{subtotal.toFixed(2)}
      </div>

      <div className="cart-item-remove">
        <button 
          onClick={() => removeItem(product.id)}
          className="remove-btn"
          title={t('cart.remove')}
        >
          🗑️
        </button>
      </div>
    </div>
  );
};

export default CartItem;
